import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useCustomerService } from "contexts/ServiceContext";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { ApiStatusException } from "services/apiErrors";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";
import { useAuth } from "contexts/AuthProvider";

export const useFetchPermissions = (): UseQueryResult<
  Record<string, boolean>
> => {
  const customerService = useCustomerService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST);
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR);

  const selectedCustomerCode = useSelectedCustomerCode()[0];

  const { userId } = useAuth() ?? {};

  const enabled = userId && selectedCustomerCode;

  return useQuery({
    queryKey: [
      "user permissions",
      { filters: { userId, selectedCustomerCode } },
    ],
    queryFn: () => {
      const eventId = trackQuery({
        endpoint: "UserPermissions",
      });
      return enabled
        ? customerService
            .fetchPermissions(userId, selectedCustomerCode)
            .catch((err: ApiStatusException) => {
              trackQueryError(
                {
                  statusCode: err.statusCode as number,
                  message: err.message,
                },
                eventId
              );
              throw err;
            })
        : Promise.reject();
    },
    enabled: !!enabled,
    staleTime: 5 * 60 * 1000,
    select: (data) => data.value,
  });
};

export default useFetchPermissions;
